import { Radio as AntRadio, RadioChangeEvent, Typography } from 'antd'
import { AbstractCheckboxProps } from 'antd/lib/checkbox/Checkbox'
import { FC } from 'react'
import './Radio.less'

export type RadioProps = AbstractCheckboxProps<RadioChangeEvent>

export const Radio: FC<RadioProps> = (props) => <AntRadio {...props} />
